<template>
  <mdb-container class="gp-has-header">
    <div v-show="showMain" class="text-left" v-if="mode=='systemAdmin'">
      <data-table :clickHandler="openTenant"
                  :columns="columns"
                  add-label="Add new Tenant"
                  show-add-button
                  :add-handler="newTenant"
                  dataSource="/tenant/list"
                  pageTitle="Tenants"/>
    </div>

    <div v-if="showTenant && currentTenant && !showWizard">
      <mdb-card>
        <mdb-card-header class="text-left">
          <div v-if="mode=='systemAdmin'">
            <h4>Tenant Settings - {{currentTenant.name}}</h4>
            <mdb-btn icon="arrow-left" rounded size="sm" @click="cancelShow">Tenant List
            </mdb-btn>
            <mdb-btn icon="database" rounded size="sm" @click="$router.push('/admin/dashboard')">Admin Dashboard
            </mdb-btn>
          </div>
          <div v-if="mode=='tenantAdmin'">
            <h4>Site Settings/Branding for {{currentTenant.name}}</h4>
          </div>
        </mdb-card-header>
        <mdb-card-body class="text-left">

          <mdb-tabs :active="0" :links="tabLinks" :transition-duration="0.5" card
                    class="mb-5"
                    tabs
                    transition-style="linear"
          >
            <div :slot="'Settings'">
              <mdb-card class="mb-2">
                <mdb-card-body>
                  <div v-if="mode=='systemAdmin'">
                    <mdb-input type="text" v-model="currentTenant.name" required
                               label="Name"/>
                    <mdb-input type="text" v-model="currentTenant.url" required
                               label="Default App URL"/>
                    <mdb-input type="text" v-model="currentTenant.staticSiteUrl" required
                               label="Default Static Site URL"/>
                    <mdb-input type="text" v-model="currentTenant.homeUrl" required
                               label="Tenant's Home Page URL"/>
                    <mdb-input type="text" v-model="currentTenant.fromEmail" required
                               label="From Email Address (for system-generated emails)"/>
                    <mdb-input type="text" v-model="currentTenant.supportEmail" required
                               label="Support (Help) Email Address"/>
                    <gp-select :dataObj="currentTenant" :possible-values="identityProviders" :required="true"
                               label="Identity Provider" propertyName="identityProvider"/>
                    <gp-select :dataObj="currentTenant" :possible-values="billingEngines" :required="true"
                               label="Billing Engine" propertyName="billingEngine"/>
                  </div>
                  <gp-select v-if="currencies.length>0"
                             :dataObj="currentTenant" :possible-values="currencies" :required="true"
                             label="Default Currency" propertyName="defaultCurrency"/>
                  <div v-if="mode!='systemAdmin'">
                    <mdb-input disabled label="Billing Engine"
                               v-model="currentTenant.billingEngine">
                    <div class="text-info small">Please contact support for other billing engine options.</div>
                    </mdb-input>
                  </div>
                  <gp-select :dataObj="currentTenant" :possible-values="defaultPlans" :required="false"
                             label="Default Paid Billing Plan" propertyName="defaultBillingPlan"/>
                  <gp-select :dataObj="currentTenant" :possible-values="trialPlans" :required="false"
                             label="Free Trial Plan" propertyName="freeTrialPlan"/>
                  <gp-select :dataObj="currentTenant" :possible-values="freeTrialRules"
                             :required="false" v-if="currentTenant.freeTrialPlan"
                             label="Free Trial Expiration Rule" propertyName="freeTrialExpirationRule"/>
                  <div class="md-form" v-if="currentTenant.freeTrialExpirationRule == 'date'">
                    <div>
                      <datetime :auto="true"
                                :format="userDetails.dateFormat"
                                :use12-hour="userDetails.timeFormat=='AM/PM'" :valueZone="userDetails.timezone"
                                :weekStart="userDetails.mondayFirst ? 1 : 7"
                                inputId="freeTrialEndDate" type="datetime"
                                v-model="currentTenant.freeTrialEndDate"/>
                      <label class="active mr-5">End Date</label>
                    </div>
                  </div>
                  <mdb-input type="number" :step="1" v-model="currentTenant.freeTrialDays" required
                             v-if="currentTenant.freeTrialExpirationRule == 'days'"
                             label="# of Days"/>

                  <gp-select :dataObj="currentTenant" :possible-values="notificationFrequencies" :required="true"
                             label="Default Notification Frequency" propertyName="defaultNotificationFrequency"/>


                  <div class="form-check">
                    <input aria-label="Require TOS?" class="form-control form-check-input" id="requireTOS"
                           type="checkbox"
                           v-model="currentTenant.requireTOS"/>
                    <label for="requireTOS">Require TOS Acknowledgement?</label>
                  </div>
                  <div class="form-check">
                    <input aria-label="New Group Approval" class="form-control form-check-input" id="newGroupApproval"
                           type="checkbox"
                           v-model="currentTenant.newGroupApproval"/>
                    <label for="newGroupApproval">New groups must be approved</label>
                  </div>
                  <div class="form-check">
                    <input aria-label="Groups May Be Public" class="form-control form-check-input"
                           id="groupsMayBePublic"
                           type="checkbox"
                           v-model="currentTenant.groupsMayBePublic"/>
                    <label for="groupsMayBePublic">Groups May Be Public</label>
                  </div>
                  <div class="form-check">
                    <input aria-label="User May Change Skin" class="form-control form-check-input"
                           id="userMayChangeSkin"
                           type="checkbox"
                           v-model="currentTenant.userMayChangeSkin"/>
                    <label for="userMayChangeSkin">User May Change Skin</label>
                  </div>
                  <div class="form-check" v-if="mode=='systemAdmin'">
                    <input aria-label="Admins may create new users" class="form-control form-check-input"
                           id="allowUserCreation"
                           type="checkbox"
                           v-model="currentTenant.allowUserCreation"/>
                    <label for="allowUserCreation">Tenant admins may create new users</label>
                  </div>
                  <div class="form-check">
                    <input aria-label="Group admins may create new members" class="form-control form-check-input"
                           id="allowMemberCreation"
                           type="checkbox"
                           v-model="currentTenant.allowMemberCreation"/>
                    <label for="allowMemberCreation">Group admins may create new members</label>
                  </div>
                  <div class="form-check">
                    <input aria-label="Use group type labels/tiers?" class="form-control form-check-input" id="useGroupTypeLabels"
                           type="checkbox"
                           v-model="currentTenant.useGroupTypeLabels"/>
                    <label for="useGroupTypeLabels">Use group type labels?</label>
                  </div>
                  <div class="form-check">
                    <input aria-label="SEO Discovery?" class="form-control form-check-input" id="seoDiscovery"
                           type="checkbox"
                           v-model="currentTenant.seoDiscovery"/>
                    <label for="seoDiscovery">SEO Discovery?</label>
                    <div class="text-info small">SEO Discovery should be disabled for test/sandbox groups.</div>
                  </div>
                  <div class="form-check">
                    <input aria-label="SEO Discovery?" class="form-control form-check-input" id="registerPublicLanding"
                           type="checkbox"
                           v-model="currentTenant.registerGoesToPublicLanding"/>
                    <label for="registerPublicLanding">Register goes to public landing?</label>
                  </div>


                </mdb-card-body>
              </mdb-card>
            </div>
            <div :slot="'Domains'">
              <mdb-card class="mb-2">
                <mdb-card-body>
                  <div>
                    <mdb-btn @click="addDomain">New Domain</mdb-btn>
                  </div>
                  <mdb-row v-for="(domain,i) in currentTenant.domains" :key="i">
                    <mdb-col>
                      <mdb-input type="text" v-model="domain.domain" placeholder="Domain" ariaDescribedBy="button-addon2">
                        <mdb-btn size="md" color="danger" @click="deleteDomain(i)" group slot="append" id="button-addon2"> <mdb-icon icon="trash"/></mdb-btn>
                      </mdb-input>
                    </mdb-col>
                  </mdb-row>

                </mdb-card-body>
              </mdb-card>
            </div>

            <div :slot="'Branding'">
              <mdb-card class="mb-2">
                <mdb-card-body>
                  <mdb-input v-model="currentTenant.stylesheet"
                              label="Stylesheet"
                              placeholder="Stylesheet"/>
                  <div>

                    <div class="label">
                        Skins in Stylesheet
                    </div>
                    <div class="text-warning small">Skins must be defined in the stylesheet!</div>
                      <cust-chip-input :chips="currentTenant.skins" id="chip-input"/>



                  </div>

                  <mdb-input v-model="currentTenant.defaultSkin"
                             label="Default Skin"
                             placeholder="Default Skin"/>

                  <system-image-input required
                                      label="Top (Header) Logo"
                                      fieldName="topLogo"
                                      @imageChanged="changeImageUrl"
                                      :imageUrl="currentTenant.topLogo" />

                  <system-image-input required
                                      label="FavIcon"
                                      fieldName="favIcon"
                                      @imageChanged="changeImageUrl"
                                      :imageUrl="currentTenant.favIcon" />

                  <system-image-input required
                                      label="Login Page Logo"
                                      fieldName="loginLogo"
                                      @imageChanged="changeImageUrl"
                                      :imageUrl="currentTenant.loginLogo" />

                  <system-image-input required
                                      label="Login Page Background"
                                      fieldName="loginBackground"
                                      @imageChanged="changeImageUrl"
                                      :imageUrl="currentTenant.loginBackground" />


                  <system-image-input v-if="mode=='systemAdmin'" required
                                         label="Powered By Logo"
                                         fieldName="poweredByLogo"
                                         @imageChanged="changeImageUrl"
                                         :imageUrl="currentTenant.poweredByLogo" />

                  <system-image-input required
                                      label="Email Logo"
                                      fieldName="emailLogo"
                                      @imageChanged="changeImageUrl"
                                      :imageUrl="currentTenant.emailLogo" />

                  <system-image-input required
                                      label="Push Notification Logo"
                                      fieldName="pushLogo"
                                      @imageChanged="changeImageUrl"
                                      :imageUrl="currentTenant.pushLogo" />

                  <system-image-input required
                                      label="System Card Image Logo"
                                      fieldName="systemCardImage"
                                      @imageChanged="changeImageUrl"
                                      :imageUrl="currentTenant.systemCardImage" />

                  <system-image-input label="PWA Icon (512x512)"
                                      fieldName="pwaIcon512"
                                      @imageChanged="changeImageUrl"
                                      :imageUrl="currentTenant.pwaIcon512" />

                  <system-image-input label="PWA Icon (192x192)"
                                      fieldName="pwaIcon192"
                                      @imageChanged="changeImageUrl"
                                      :imageUrl="currentTenant.pwaIcon192" />


                  <system-page-selector :dataObj="currentTenant" :page-list="allPages"
                             label="App Public Home Page" propertyName="appHomePage"/>
                  <system-page-selector :dataObj="currentTenant" :page-list="allPages"
                             label="Static Home Page" propertyName="staticHomePage"/>
                  <system-page-selector :dataObj="currentTenant" :page-list="allPages"
                             label="Static Page Head Tag" propertyName="staticHead"/>
                  <system-page-selector :dataObj="currentTenant" :page-list="allPages"
                             label="Static Page Header" propertyName="staticHeader"/>
                  <system-page-selector :dataObj="currentTenant" :page-list="allPages"
                             label="Static Footer" propertyName="staticFooter"/>
                  <system-page-selector :dataObj="currentTenant" :page-list="allPages"
                             label="Static Post-Close Tag" propertyName="staticBodyClose"/>
                  <system-page-selector :dataObj="currentTenant" :page-list="allPages"
                             label="Pricing Information" propertyName="pricingInfo"/>
                </mdb-card-body>
              </mdb-card>
            </div>

            <div :slot="'Online Features'" v-if="!currentTenant.id">
              <mdb-card class="mb-2">
                <mdb-card-body>
                  <div class="text-info small">
                    <mdb-icon color="danger" icon="exclamation"/>
                    Save new tenant first.
                  </div>
                </mdb-card-body>
              </mdb-card>
            </div>

            <div :slot="'Batch Features'" v-if="!currentTenant.id">
              <mdb-card class="mb-2">
                <mdb-card-body>
                  <div class="text-info small">
                    <mdb-icon color="danger" icon="exclamation"/>
                    Save new tenant first.
                  </div>
                </mdb-card-body>
              </mdb-card>
            </div>

            <div :slot="'Admin Users'" v-if="!currentTenant.id">
              <mdb-card class="mb-2">
                <mdb-card-body>
                  <div class="text-info small">
                    <mdb-icon color="danger" icon="exclamation"/>
                    Save new tenant first.
                  </div>
                </mdb-card-body>
              </mdb-card>
            </div>

            <div :slot="'Languages'" v-if="!currentTenant.id">
              <mdb-card class="mb-2">
                <mdb-card-body>
                  <div class="text-info small">
                    <mdb-icon color="danger" icon="exclamation"/>
                    Save new tenant first.
                  </div>
                </mdb-card-body>
              </mdb-card>
            </div>

            <div :slot="'Online Features'" v-if="currentTenant.id">
              <mdb-card class="mb-2">
                <mdb-card-body>
                  <div v-for="(feature,i) in currentTenant.onlineFeatures">
                    <div class="form-check">
                      <input :aria-label="feature.label" class="form-control form-check-input" :id="feature.name"
                             type="checkbox"
                             v-model="feature.enabled"/>
                      <label :for="feature.name">{{ feature.label }}</label>
                    </div>
                  </div>
                </mdb-card-body>
              </mdb-card>
            </div>

            <div :slot="'Batch Features'" v-if="currentTenant.id">
              <mdb-card class="mb-2">
                <mdb-card-body>
                  <div v-for="(feature,i) in currentTenant.batchFeatures">
                    <div class="form-check">
                      <input :aria-label="feature.label" class="form-control form-check-input" :id="feature.name"
                             type="checkbox"
                             v-model="feature.enabled"/>
                      <label :for="feature.name">{{ feature.label }}</label>
                    </div>
                  </div>
                </mdb-card-body>
              </mdb-card>
            </div>

            <div :slot="'Admin Users'" v-if="currentTenant.id">
              <mdb-card class="mb-2">
                <mdb-card-body>
                  <div v-if="showSearch">
                    <mdb-input v-model="userSearch" label="Add a New User" @keydown.native="handleKeydown"/>
                    <mdb-btn @click="findUser" icon="search" size="sm" rounded>Search</mdb-btn>
                    <mdb-btn @click="showSearch=false" icon="minus-circle" size="sm" rounded>Cancel</mdb-btn>
                    <div v-for="user in foundUsers" :key="user.id">
                      <avatar :avatar="user.avatar" :size="50" :name="user.name"/>
                      <h3>{{ user.name }}</h3>
                      ({{ user.email }})
                      <mdb-btn @click="addAdmin(user)" icon="check" color="success" rounded size="sm">Select
                      </mdb-btn>
                      <hr/>
                    </div>
                  </div>
                  <div v-if="!showSearch">
                    <mdb-btn @click="openSearch" icon="plus-circle" size="sm" rounded>New Admin</mdb-btn>
                    <div v-for="(admin,i) in currentTenant.admins" :key="i">
                      <div class="form-check">
                        <avatar :avatar="admin.avatar" :size="50" :name="admin.name"/>
                        <h3>{{ admin.name }}</h3>
                        ({{ admin.email }})
                        <mdb-btn @click="deleteAdmin(admin)" icon="trash" color="danger" rounded size="sm">Delete
                        </mdb-btn>
                      </div>
                      <hr/>
                    </div>
                  </div>
                </mdb-card-body>
              </mdb-card>
            </div>

            <div :slot="'Languages'" v-if="currentTenant.id">
              <mdb-card class="mb-2">
                <mdb-card-body>
                    <mdb-tbl striped responsive>
                      <mdb-tbl-head>
                        <tr>
                          <th>ISO 639-1 Code</th>
                          <th>English Name</th>
                          <th>Native Name</th>
                          <th>Home Pages</th>
                          <th>Translating Only?</th>
                          <th>&nbsp;</th>
                        </tr>
                      </mdb-tbl-head>
                    <tr v-for="(lang,i) in currentTenant.languages" :key="i">
                      <td><mdb-input :disabled="lang.language=='en'" type="text" v-model="lang.language" /></td>
                      <td><mdb-input type="text" v-model="lang.englishName" /></td>
                      <td><mdb-input type="text" v-model="lang.nativeName" /></td>
                      <td><div><system-page-selector v-if="lang.language!='en'" :dataObj="lang" :page-list="allPages"
                                                     label="Application" propertyName="appHomePage"/></div>
                          <div><system-page-selector v-if="lang.language!='en'" :dataObj="lang" :page-list="allPages"
                                                     label="Static" propertyName="staticHomePage"/></div>
                        <div><system-page-selector v-if="lang.language!='en'" :dataObj="lang" :page-list="allPages"
                                                   label="Static Header" propertyName="staticHeader"/></div>
                        <div><system-page-selector v-if="lang.language!='en'" :dataObj="lang" :page-list="allPages"
                                                   label="Static Footer" propertyName="staticFooter"/></div>
                      <td><mdb-input :id="'cb-'+i" type="checkbox" v-model="lang.translatingOnly" /></td>
                      <td><mdb-btn floating rounded color="danger" tag="a" size="sm" icon="trash" :disabled="lang.language=='en'" @click="deleteLang(lang)"/></td>
                    </tr>
                    </mdb-tbl>
                  <mdb-btn floating rounded color="success" tag="a" size="sm" icon="plus" @click="addLang"/>

                </mdb-card-body>
              </mdb-card>
            </div>



            <div :slot="'Meta Data'" v-if="currentTenant.id">
              <mdb-card class="mb-2">
                <mdb-card-body>
                  <div>
                    <mdb-btn @click="addProperty" icon="plus-circle" size="sm" rounded>New Property</mdb-btn>
                    <mdb-tbl responsive striped>
                      <mdb-tbl-head class="primary-color text-white">
                        <tr>
                          <th>Property</th>
                          <th>Content</th>
                          <th>&nbsp;</th>
                        </tr>
                      </mdb-tbl-head>
                      <mdb-tbl-body>
                        <tr v-for="(prop,i) in currentTenant.metaData" :key="i">
                          <td>
                            <mdb-input type="text" v-model="prop.property" required
                                       label="Property"/>
                          </td>
                          <td>
                            <mdb-input type="text" v-model="prop.content" required
                                       label="Content"/>
                          </td>
                          <td>
                            <mdb-btn @click="deleteProperty(prop)" icon="trash" color="danger" tag="a" floating
                                     size="sm"/>
                          </td>
                          <hr/>
                        </tr>
                      </mdb-tbl-body>
                    </mdb-tbl>
                  </div>
                </mdb-card-body>
              </mdb-card>
            </div>

          </mdb-tabs>
        </mdb-card-body>
        <mdb-card-footer class="text-left">
          <mdb-btn @click="save" icon="save" color="success">Save</mdb-btn>
        </mdb-card-footer>
      </mdb-card>
    </div>

    <yes-no-modal @yes="doDeleteAdmin" @no="deleteModal=false" v-if="deleteModal"/>

  </mdb-container>
</template>

<script>
import dataTable from '../common/DataTable'
import api from "../../services/groupsPlaceApi";
import YesNoModal from "../common/YesNoModal";
import gpSelect from "../common/GPSelect";
import Avatar from "../common/Avatar";
import {Datetime} from 'vue-datetime'
import SystemImageInput from "../common/SystemImageInput";
import systemPageSelector from "../common/SystemPageSelector";
import {custChipInput} from "../common/CustChipInput";
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbChip,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbRow,
  mdbTabs,
  mdbTbl,
  mdbTblBody,
  mdbTblHead,
} from 'mdbvue';

export default {
  name: 'tenant-admin',
  components: {
    mdbContainer, mdbBtn,
    mdbBadge,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbInput,
    mdbIcon,
    mdbChip,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbRow,
    mdbCol,
    mdbTabs,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    dataTable,
    YesNoModal,
    gpSelect,
    Avatar,
    Datetime,
    SystemImageInput,
    systemPageSelector,
    custChipInput
  },
  computed: {
    config: function () {
      return this.$store.state.settings
    },
    userDetails: function () {
      return this.$store.state.userDetails
    },
    settings: function () {
      return this.$store.state.settings
    }
  },
  data() {
    return {
      columns: [
        {label: "ID", field: "id"},
        {label: "Name", field: "name"},
        {label: "URL", field: "url"}
      ],
      mode: "tenantAdmin",
      currentTenant: null,
      showTenant: false,
      showMain: true,
      changeGlobalGroupModal: false,
      yesNoModal: false,
      imageCallback: null,
      showImageSelector: false,
      wizardData: null,
      showWizard: false,
      currencies: [],
      deleteCandidate: null,
      deleteModal: false,
      userSearch: "",
      showSearch: false,
      foundUsers: [],
      defaultPlans: [],
      trialPlans: null,
      allPages: [],
      identityProviders: [
        {value: "LOCAL", text: "Local-Username/Password Only"},
        {value: "COGNITO", text: "Cognito"},
        {value: "AUTH0", text: "Auth0"}
      ],
      billingEngines: [
        {text: "Ezumee", value: "EzumeeBillingEngine"},
        {text: "Groups Place", value: "GPBillingEngine"},
        {text: "Manual", value: "ManualBillingEngine"},
        {text: "ACC Squamish", value: "AccBillingEngine"},
        {text: "-- NONE -- ", value: "NoBillingEngine"}
      ],
      freeTrialRules: [
        {text: "-- NONE -- ", value: "none"},
        {text: "Number of Days", value: "days"},
        {text: "Set Date", value: "date"}
      ],
      notificationFrequencies: [
        {text: "Immediate", value: "Immediate"},
        {text: "Daily", value: "Daily"},
        {text: "Weekly", value: "Weekly"},
        {text: "None", value: "None"}
      ],
      tabLinks: []
    }
  },
  mounted() {
    document.title = "Tenant Settings"
    if (this.$route.path == "/custom/settings") {
      this.mode = "tenantAdmin"
      this.tabLinks = [{text: 'Settings'}, {text: 'Branding'}, {text: 'Languages'}]
    }
    if (this.$route.path == "/admin/tenants") {
      this.mode = "systemAdmin"
      this.tabLinks = [{text: 'Settings'}, {text: 'Domains'}, {text: 'Branding'}, {text: 'Meta Data'},
        {text: 'Online Features'}, {text: 'Batch Features'}, {text: 'Admin Users'}, {text: 'Languages'}]
    }
    if (this.$route.params.id && this.mode == "systemAdmin") {
      this.openTenant({id: this.$route.params.id})
    }
    if (this.mode == "tenantAdmin") {
      this.openTenant(null)
    }
    api.get("/public/countryList").then(
      (results) => {
        this.countries = results.data
        for (const c of this.countries) {
          let curr = {value: c.currencyCode, text: c.currencyCode + " - " + c.currencySymbol}
          this.currencies.push(curr)
        }
      },
      (error) => {
        this.$notify.error({message: error.response.data, timeOut: 20000})
      })

  },
  methods: {
    changeImageUrl(upd) {
      this.currentTenant[upd.fieldName] = upd.url
      this.resizeTabs()
    },
    handleKeydown: function (e) {
      if (e.keyCode == 13) {
        if (this.userSearch) this.findUser()
        else this.foundUsers = []
      }
    },
    resizeTabs: function () {
      this.$nextTick(() => {
        let el = document.getElementsByClassName("tab-content")
        if (el && el.length > 0) {
          el[0].setAttribute("style", "")  //remove previously calculated height; mdb-tab doesn't resize with content!
        }
      });
    },
    openSearch: function () {
      this.showSearch = true
      this.resizeTabs()
    },
    addAdmin: function (a) {
      this.currentTenant.admins.push({id: null, userId: a.id, name: a.name, email: a.email, avatar: a.avatar})
      this.showSearch = false
      this.userSearch = ""
      this.foundUsers = []
      this.resizeTabs()
    },
    deleteAdmin: function (a) {
      this.deleteCandidate = a
      this.deleteModal = true
    },
    doDeleteAdmin: function () {
      this.deleteModal = false
      let i = this.currentTenant.admins.indexOf(this.deleteCandidate)
      if (i >= 0) this.currentTenant.admins.splice(i, 1)
      this.deleteModal = null
    },
    deleteLang(l) {
      let loc = this.currentTenant.languages.indexOf(l)
      if (loc > -1) this.currentTenant.languages.splice(loc,1)
      this.resizeTabs()
    },
    addLang() {
      let row = { language: "", englishName: "", nativeName: "", translatingOnly: true, id: null, appHomePage: null, staticHomePage: null}
      this.currentTenant.languages.unshift(row)
      this.resizeTabs()
    },
    findUser: function () {
      let url = "/user/list?q=" + this.userSearch + "&max=10&offset=0"
      this.$store.dispatch("setExecuting", true)
      api.get(url, {linkCode: this.linkCode}).then(
        (results) => {
          this.foundUsers = results.data.rows
          this.resizeTabs()
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    newTenant: function () {
      this.currentTenant = {
        id: null,
        name: "",
        url: "",
        topLogo: "",
        fromEmail: "",
        emailLogo: "",
        pushLogo: "",
        supportEmail: "",
        billingEngine: "",
        defaultCurrency: "",
        requireTOS: false,
        tosUrl: "",
        newGroupApproval: false,
        identityProvider: "LOCAL",
        seoDiscovery: false,
        defaultNotificationFrequency: "Immediate",
        admins: [],
        domains: [ {id: null, domain: ""}]
      }
      this.showMain = false
      this.showTenant = true
    },
    cancelShow: function () {
      this.showMain = true
      this.currentTenant = null
      this.showTenant = false
      if (this.$route.params.id) this.$router.replace("/admin/tenants")
    },
    deleteDomain(row) {
      this.currentTenant.domains.splice(row,1)
    },
    addDomain() {
      let d = {id: null, domain: ""}
      this.currentTenant.domains.unshift(d)
      this.resizeTabs()
    },

    openTenant: function (row) {
      this.$store.dispatch("setExecuting", true)
      let url = "/tenant/details/"
      if (row) url += row.id
      api.get(url).then(
        (results) => {
          this.currentTenant = results.data.tenant
          this.trialPlans = [{value: null, text: "---None---"}]
          this.defaultPlans = [{value: null, text: "---None---"}]
          for (let i = 0; i < results.data.subscriptionPlans.length; i++) {
            this.trialPlans.push(results.data.subscriptionPlans[i]);
            this.defaultPlans.push(results.data.subscriptionPlans[i]);
          }
          this.allPages = results.data.pages
          this.showMain = false
          this.showTenant = true
          this.resizeTabs()
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    save: function () {
      this.$store.dispatch("setExecuting", true)
      api.post("/tenant/settings/", this.currentTenant).then(
        (results) => {
          this.$notify.success({message: "Saved", timeOut: 3000})
          if (!this.currentTenant.id) {
            this.currentTenant.id = results.data.id
            this.currentTenant.onlineFeatures = results.data.onlineFeatures
            this.currentTenant.batchFeatures = results.data.batchFeatures
            this.currentTenant.languages = results.data.languages
          }
          this.$store.dispatch("setDataTableReload", true)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    addProperty: function () {
      this.currentTenant.metaData.unshift({property: "", content: ""})
      this.resizeTabs()
    },
    deleteProperty: function (prop) {
      let loc = this.currentTenant.metaData.indexOf(prop)
      if (loc >= 0) this.currentTenant.metaData.splice(loc, 1)
    }
  }
};

</script>
<style lang="scss">
@import '~vue-datetime/dist/vue-datetime.min';
</style>
